<section class="fields-panel">
  <h4>OEM fields</h4>
  <p class="muted small">
    Link a {{ providerLabel }} field to a Harvest Mate block so telemetry from
    that field is attributed correctly.
  </p>

  @if (cnhUnavailable) {
  <div class="cnh-unavailable">
    Field linking for Case New Holland is temporarily unavailable. Will be
    enabled once the vendor base URL is confirmed.
  </div>
  }

  @if (!cnhUnavailable && loading) {
  <div class="muted">Loading fields&hellip;</div>
  } @if (!cnhUnavailable && errorMessage) {
  <div class="error">{{ errorMessage }}</div>
  }

  @if (!cnhUnavailable && !loading && !errorMessage) {
  @if (fields.length === 0) {
  <div class="muted">No fields from {{ providerLabel }}.</div>
  } @else {
  <!-- SRA003-502: one unified table, one row per field, grouped by parent OEM
       farm; each row's action is Link or Unlink depending on its state. -->
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Field</th>
        <th scope="col">Area (ha)</th>
        <th scope="col">Harvest Mate farm</th>
        <th scope="col">Block</th>
        <th scope="col">Status</th>
        <th scope="col"><span class="visually-hidden">Actions</span></th>
      </tr>
    </thead>
    @for (group of fieldGroups(); track group.farmId) {
    <tbody>
      <tr class="field-group-row">
        <th colspan="6" scope="colgroup">
          {{ group.farmName }}
          @if (group.linkedHmFarmName) {
          <span class="group-link">&rarr; {{ group.linkedHmFarmName }}</span>
          } @else {
          <span class="group-unlinked">(not linked)</span>
          }
        </th>
      </tr>
      @for (f of group.fields; track f.oem_field_id) {
      <tr>
        @if (rowFor(f); as state) {
        <td>{{ f.name || f.oem_field_id }}</td>
        <td>{{ f.area_ha != null ? (f.area_ha | number: '1.0-2') : '—' }}</td>
        @if (isLinked(f)) {
        <td>{{ group.linkedHmFarmName || '—' }}</td>
        <!-- SRA003-458: human-readable block_number; raw block id only as fallback -->
        <td [title]="f.linked_block_id">
          {{ f.linked_block_number || f.linked_block_id }}
        </td>
        <td><span class="status-chip linked">Linked</span></td>
        <td>
          <button
            class="btn-small"
            type="button"
            (click)="unlink(f)"
            [disabled]="state.busy"
          >
            Unlink
          </button>
        </td>
        } @else if (isLinkedElsewhere(f)) {
        <!-- SRA003-524: claimed by another operator in the org. Privacy-aware —
             no identity, just shown as unavailable so it isn't offered (a link
             would 409). -->
        <td class="muted small">Linked by another operator</td>
        <td>&mdash;</td>
        <td><span class="status-chip unlinked">Linked elsewhere</span></td>
        <td><span class="muted small">Unavailable</span></td>
        } @else {
        <td>
          <select
            [(ngModel)]="state.farmExtId"
            (ngModelChange)="onFarmChange(f)"
            [disabled]="state.busy || isFarmLocked(f)"
          >
            <option [ngValue]="undefined">Select a farm&hellip;</option>
            @for (grp of farmGroups; track grp.growerName) {
            <optgroup [label]="grp.growerName">
              @for (hm of grp.farms; track hm.extId) {
              <!-- SRA003-502: disable an HM farm already linked to an OEM farm
                   (any provider), EXCEPT the one this row is pre-filled to. -->
              <option
                [ngValue]="hm.extId"
                [disabled]="!!hm.linkedLabel && hm.extId !== state.farmExtId"
              >
                {{ hm.name }}@if (hm.linkedLabel && hm.extId !== state.farmExtId) {
                — {{ hm.linkedLabel }}}
              </option>
              }
            </optgroup>
            }
          </select>
        </td>
        <td>
          <select
            [(ngModel)]="state.blockIdInput"
            [disabled]="state.busy || !state.farmExtId || state.loadingBlocks"
          >
            <option [ngValue]="undefined">
              {{ state.loadingBlocks ? 'Loading…' : 'Select a block…' }}
            </option>
            @for (b of state.blocks; track b.id) {
            <option [ngValue]="b.id" [disabled]="!!b.crossClaimedLabel">
              {{ b.block_number }}@if (b.crossClaimedLabel) { — already linked to
              {{ b.crossClaimedLabel }}}
            </option>
            }
          </select>
        </td>
        <td><span class="status-chip unlinked">Not linked</span></td>
        <td>
          <button
            class="btn-oem-primary"
            type="button"
            (click)="link(f)"
            [disabled]="state.busy"
          >
            Link
          </button>
        </td>
        }
        }
      </tr>
      }
    </tbody>
    }
  </table>
  }
  }
</section>
